// extracted by mini-css-extract-plugin
module.exports = {"titleWrapp":"Range-module--titleWrapp--3QBhC","sliderWrapp":"Range-module--sliderWrapp--1dAru"};